Overrides for a posting instruction.
